export const LIBRARY_GET_RECOMMENDED_REQUESTING =
  "LIBRARY_GET_RECOMMENDED_REQUESTING";
export const LIBRARY_GET_RECOMMENDED_ERROR = "LIBRARY_GET_RECOMMENDED_ERROR";
export const LIBRARY_GET_RECOMMENDED_SUCCESS =
  "LIBRARY_GET_RECOMMENDED_SUCCESS";

export const LIBRARY_GET_PREMIUM_REQUESTING = "LIBRARY_GET_PREMIUM_REQUESTING";
export const LIBRARY_GET_PREMIUM_ERROR = "LIBRARY_GET_PREMIUM_ERROR";
export const LIBRARY_GET_PREMIUM_SUCCESS = "LIBRARY_GET_PREMIUM_SUCCESS";

export const LIBRARY_GET_ALL_REQUESTING = "LIBRARY_GET_ALL_REQUESTING";
export const LIBRARY_GET_ALL_ERROR = "LIBRARY_GET_ALL_ERROR";
export const LIBRARY_GET_ALL_SUCCESS = "LIBRARY_GET_ALL_SUCCESS";

export const LIBRARY_CLICK_TOPIC = "LIBRARY_CLICK_TOPIC";

export const LIBRARY_TOPIC_FEEDBACK_IDEA_CHANGE =
  "LIBRARY_TOPIC_FEEDBACK_IDEA_CHANGE";

export const LIBRARY_SUBMIT_TOPIC_FEEDBACK_REQUESTING =
  "LIBRARY_SUBMIT_TOPIC_FEEDBACK_REQUESTING";
export const LIBRARY_SUBMIT_TOPIC_FEEDBACK_SUCCESS =
  "LIBRARY_SUBMIT_TOPIC_FEEDBACK_SUCCESS";
export const LIBRARY_SUBMIT_TOPIC_FEEDBACK_ERROR =
  "LIBRARY_SUBMIT_TOPIC_FEEDBACK_ERROR";
